module.exports = __webpack_public_path__ + "portal-static/img/shifan02.69c05c05.png";